var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"smart-traffic"},[_c('tabs',{attrs:{"list":_vm.tablist},model:{value:(_vm.sel),callback:function ($$v) {_vm.sel=$$v},expression:"sel"}}),_c('div',{staticClass:"main"},[(_vm.sel === 0)?_c('mobi'):_vm._e(),(_vm.sel === 1)?_c('sid'):_vm._e()],1),_c('ourserviceBtnVue')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }